module.exports = __webpack_public_path__ + "static/trackingcustomerbehavior-35235fee2f84a97b701ffb29dd349b75.png";